var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tariff-contract-offer" },
    [
      _c(
        "Portal",
        {
          attrs: {
            to: "contract-offer-aside",
            slim: "",
            disabled: _vm.isSreenSizeGreaterThenMD,
          },
        },
        [
          _c(
            "div",
            { staticClass: "tariff-contract-offer__aside" },
            [
              _c("TableOfContents", {
                staticClass: "tariff-contract-offer__table-of-contents",
              }),
              _vm._v(" "),
              _vm.contractStatus != "service" &&
              _vm.contractStatus != "terminated"
                ? _c("MarginConfirmationBlock", {
                    staticClass: "tariff-contract-offer__confirmation",
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tariff-contract-offer__main" },
        [
          _c("StatusAndHistory", {
            staticClass: "tariff-contract-offer__status-and-history",
          }),
          _vm._v(" "),
          _c("PortalTarget", {
            attrs: { name: "contract-offer-aside", slim: "" },
          }),
          _vm._v(" "),
          _c("ContractOfferWrapper", {
            ref: "contract-offer-wrapper",
            staticClass: "tariff-contract-offer__wrapper",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }